/**
 * @generated SignedSource<<43b0c80db3d1efffe3a143c66af71ef7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SelectDashboardListQuery$variables = Record<PropertyKey, never>;
export type SelectDashboardListQuery$data = {
  readonly store: {
    readonly dashboards: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type SelectDashboardListQuery = {
  response: SelectDashboardListQuery$data;
  variables: SelectDashboardListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "dashboards",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectDashboardListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectDashboardListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f21e1c6b83cff6f99f31a04071b828fc",
    "id": null,
    "metadata": {},
    "name": "SelectDashboardListQuery",
    "operationKind": "query",
    "text": "query SelectDashboardListQuery {\n  store {\n    dashboards {\n      id\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ad7ed1cf7cd36ae63466d3d68c28e9e";

export default node;
